import { FieldErrors } from 'react-hook-form';
import { ValidationError } from '../../initializers/yup';

export type { ValidationError };

/** React Hook Form nests errors ({ a: { b: { message } } }); walk the dot path. */
export const getError = (
  name: string,
  errors: FieldErrors,
): ValidationError | string | undefined => {
  let cursor: any = errors;
  for (const part of name.split('.')) {
    cursor = cursor?.[part];
    if (cursor == null) return undefined;
  }
  return cursor?.message;
};
